import { makeDefinitionFor } from '../../../helpers/endpoint.definition.details.generator';
import { generateValidationError, success } from '../../../shared/api.response.def';
import { collection } from '../../../shared/collection.json.def';

export const definition = makeDefinitionFor(
	'/collection/{collection_id}.json',
	{
		description: 'Get the data of a collection',
		method: 'get',
		summary: 'Collection information',
		tags: ['Collection'],
		params: [
			{
				$ref: '#/components/parameters/ikeDepartmentId',
			},
			{
				$ref: '#/components/parameters/collectionIdPath',
			},
		],
	},
	[
		{
			code: 200,
			description: success,
			schema: collection,
		},
		generateValidationError(),
	]
);
